export const chargerDetailsInputDebounce = 300;
